<template>
  <div>
    <div
      class="flex flex-row mb-3 p-5"
      v-bind:class="{
        'bg-indigo-300': !queue_failure && !processingQueue && minimized,
        'bg-green-300': !queue_failure && processingQueue && minimized,
        'bg-red-300': queue_failure && minimized,
      }"
    >
      <base-button-primary-small @click="handleUpdateAlbum" icon="pencil-alt">
        Edit
      </base-button-primary-small>

      <base-button-white-small
        v-if="processingQueue && queue_waiting.length"
        class="ml-3"
        @click="handleStopProcess"
        icon="pause-circle"
      >
        Pause
      </base-button-white-small>

      <base-button-white-small
        v-if="!processingQueue && queue_waiting.length"
        class="ml-3"
        @click="handleStartProcess"
        icon="play"
      >
        Start
      </base-button-white-small>

      <base-button-white-small
        class="ml-3"
        @click="handleRemoveQueue"
        icon="minus-circle"
      >
        Remove
      </base-button-white-small>
      <base-button-white-small
        v-if="!minimized"
        class="ml-3"
        @click="handleMinimize"
        icon="compress"
      >
        Minimize
      </base-button-white-small>
      <base-button-white-small
        v-if="minimized"
        class="ml-3"
        @click="handleMaximize"
        icon="expand"
      >
        Maximize
      </base-button-white-small>
      <base-button-white-small
        class="ml-3"
        @click="handleCreateDisplayGroup"
        icon="object-group"
      >
        Display Group
      </base-button-white-small>
      <div v-if="minimized" class="text-sm ml-3">
        {{ queueObj.name }}
        <br />
        <span>Queue: {{ queue.length }}</span>
        <span class="ml-3">Waiting: {{ queue_waiting.length }}</span>
        <span class="ml-3"
          >Uploaded: {{ queue.length - queue_waiting.length }}</span
        >
        <span class="ml-3">{{
          queue_failure ? "FAILURE" : processingQueue ? "PROCESSING" : "STANDBY"
        }}</span>
      </div>
    </div>
    <div v-if="!minimized" class="flex flex-row">
      <div class="w-full">
        <div>
          <div class="grid grid-cols-4 gap-4">
            <div class="col-span-4">
              <form enctype="multipart/form-data" novalidate>
                <div class="dropbox bg-indigo-300">
                  <input
                    type="file"
                    multiple
                    :name="uploadFieldName"
                    @change="
                      filesChange($event.target.files);
                      fileCount = $event.target.files.length;
                    "
                    accept="image/*"
                    class="input-file"
                  />
                  <p>Add files to {{ queueObj.name }}</p>
                </div>
              </form>
            </div>

            <div
              v-for="(photo, index) in queue"
              :key="index"
              class="text-center mt-3"
            >
              <img
                ref="previewimage"
                style="max-height: 125px; margin-left: auto; margin-right: auto"
              />
              {{ photo.name }}
              <br />
              <base-button-warning-small
                v-if="photo.status === 'waiting'"
                @click="removeFromQueue(index)"
                icon="times-circle"
              >
                Remove
              </base-button-warning-small>
              <base-button-danger-small
                v-if="photo.status === 'processed'"
                @click="removeFromServer(index)"
                icon="trash"
              >
                Remove
              </base-button-danger-small>
              <base-button-primary-small
                v-if="photo.status === 'processing'"
                icon="spinner"
              >
                Uploading
              </base-button-primary-small>

              <base-button-warning-small
                v-if="photo.status === 'failed'"
                @click="reQueue(index)"
                icon="chevron-right"
              >
                Re-Try
              </base-button-warning-small>
            </div>

            <div class="col-span-4 my-1">
              <base-button-success-small
                v-if="!processingQueue && queue_waiting.length"
                @click="handleStartProcess"
                icon="cloud-upload-alt"
              >
                Begin uploading {{ queue_waiting.length }}
                {{ queue_waiting.length === 1 ? "photo" : "photos" }}
              </base-button-success-small>
              <base-button-primary-small
                v-if="processingQueue"
                @click="handleStopProcess"
                icon="pause-circle"
              >
                Pause
              </base-button-primary-small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButtonWhiteSmall from "../ui/buttons/BaseButtonWhiteSmall";
// import Compressor from "compressorjs";

export default {
  name: "Queue",
  props: {
    queueObj: {},
  },
  components: {
    BaseButtonWhiteSmall,
  },
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      queue: [],
      processingQueue: false,
      minimized: false,
    };
  },
  methods: {
    handleUpdateAlbum() {
      this.$emit("updateAlbum", this.queueObj);
    },
    handleCreateDisplayGroup() {
      this.$emit("createDisplayGroup", this.queueObj);
    },
    handleRemoveQueue() {
      this.$emit("removeQueue", this.queueObj);
    },
    handleMinimize() {
      this.minimized = true;
    },
    handleMaximize() {
      this.minimized = false;
      this.setImagePreviews();
    },
    reQueue(index) {
      this.queue[index].status = "waiting";
      if (!this.processingQueue) {
        this.handleStartProcess();
      }
    },
    removeFromServer(index) {
      if (
        confirm("Are you sure you want to remove this picture from the server?")
      ) {
        this.$store
          .dispatch("queue/delete_photo", { id: this.queue[index].id })
          .then((success) => {
            if (success) {
              this.$notify({
                title: "Photo",
                message: "Removed from server",
                type: "success",
              });
              this.removeFromQueue(index);
            } else {
              this.queue[index].status = "failed";
            }
          });
      }
    },
    handleStartProcess() {
      this.processingQueue = true;
      this.processNext();
    },
    handleStopProcess() {
      this.processingQueue = false;
    },
    removeFromQueue(index) {
      this.queue.splice(index, 1);
      this.setImagePreviews();
    },
    processNext() {
      if (this.processingQueue) {
        const index = this.queue.findIndex(
          (element) => element.status === "waiting"
        );
        if (index != -1) {
          this.queue[index].status = "processing";
          this.$store
            .dispatch("queue/upload_photo", this.queue[index])
            .then((resp) => {
              if (resp.success) {
                this.queue[index].status = "processed";
                this.queue[index].id = resp.photo.id;
              } else {
                this.queue[index].status = "failed";
              }
              this.processNext();
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.handleStopProcess();
        }
      }
    },
    addToQueue(fileList) {
      let acceptedFiles = ["image/jpeg", "image/jpg", "image/png"];
      // Convert FileList to Array before using forEach
      Array.from(fileList).forEach((file) => {
        if (acceptedFiles.includes(file.type)) {
          let add = true;
          this.queue.forEach((element) => {
            if (element.name === file.name) {
              add = false;
            }
          });
          if (add) {
            // if (file.size > 4000000) {
            //   let q = 0.5;
            //   if (file.size < 10000000) {
            //     q = 0.9;
            //   } else if (file.size < 12000000) {
            //     q = 0.7;
            //   }
            //   const that = this;
            //   new Compressor(file, {
            //     checkOrientation: false,
            //     quality: q,
            //     success(result) {
            //       that.queue.push({
            //         file: result,
            //         name: result.name,
            //         album_id: that.queueObj.id,
            //         status: "waiting",
            //       });
            //       that.setImagePreviews();
            //       that.handleStartProcess();
            //     },
            //   });
            // } else {
            this.queue.push({
              file: file,
              name: file.name,
              album_id: this.queueObj.id,
              status: "waiting",
            });
            // this.handleStartProcess();
            // }
          }
        } else {
          this.$notify({
            title: "Photo",
            message: "File type " + file.type + " is not allowed",
            type: "error",
          });
        }
      });
      this.setImagePreviews();
    },
    setImagePreviews() {
      this.$nextTick(() => {
        this.queue.forEach((file, index) => {
          let element = this.$refs["previewimage"][index];
          if (file.path) {
            const imageRequest = JSON.stringify({
              bucket: process.env.VUE_APP_AWS_S3_MAIN_BUCKET,
              key: "originals/" + file.path + "/" + file.file_name,
              edits: {
                resize: {
                  width: 300,
                  height: 300,
                  fit: "inside",
                },
              },
            });
            element.src =
              process.env.VUE_APP_CLOUDFRONT_ENDPOINT +
              "/" +
              btoa(imageRequest);
          } else {
            let reader = new FileReader();
            reader.addEventListener("load", function () {
              element.src = reader.result;
            });
            reader.readAsDataURL(file.file);
          }
        });
      });
    },
    filesChange(fileList) {
      if (fileList.length) {
        this.addToQueue(fileList);
        this.handleStartProcess();
      }
    },
  },
  computed: {
    queue_failure: function () {
      return this.queue.filter((item) => item.status === "failed").length;
    },
    queue_waiting: function () {
      return this.queue.filter((item) => item.status === "waiting");
    },
  },
  mounted() {
    if (this.queueObj.photos && this.queueObj.photos.length) {
      this.queueObj.photos.forEach((photo) => {
        this.queue.push({
          name: photo.name,
          album_id: photo.album_id,
          status: "processed",
          id: photo.id,
          path: photo.path,
          file_name: photo.file_name,
        });
      });
      this.setImagePreviews();
    }
  },
};
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey;
  outline-offset: -10px;
  /*background: lightcyan;*/
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  /*position: relative;*/
  cursor: pointer;
}
.input-file {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue;
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
